<template lang="pug">
div
  v-list(dense nav)
    v-list-item.new-component-item(@click="showNewDialog = true")
      v-list-item-icon.mr-2.my-2
        v-icon(small) add
      v-list-item-content
        v-list-item-title(style="font-size:0.8rem") New Component
    v-divider.mb-1
    component-card(
      v-for="component in components"
      :key="component.id"
      :component="component"
      @edit-me="editTarget = component; showEditDialog = true"
      @delete-me="deleteTarget = component; showDeleteDialog = true"
    )

  v-dialog(v-model="showNewDialog" max-width="500")
    new-component-form(@close-dialog="showNewDialog = false")

  v-dialog(v-model="showEditDialog" max-width="500")
    edit-component-form(v-if="editTarget" :component="editTarget" @close-dialog="showEditDialog = false")

  v-dialog(v-model="showDeleteDialog" max-width="500")
    v-card(v-if="deleteTarget")
      v-card-title.subtitle-1 Delete "{{ deleteTarget.title }}"?
      v-card-text.caption It will be lost forever.
      v-card-actions
        v-spacer
        v-btn(text small @click="showDeleteDialog = false") Cancel
        v-btn(text small color="error" @click="confirmDelete") Delete
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import ComponentCard from './ComponentCard.vue'
  import NewComponentForm from './NewComponentForm.vue'
  import EditComponentForm from './EditComponentForm.vue'

  export default {
    props: ["components"],

    components: { ComponentCard, NewComponentForm, EditComponentForm },

    data() {
      return {
        showNewDialog: false,
        showEditDialog: false,
        showDeleteDialog: false,
        editTarget: null,
        deleteTarget: null,
      }
    },

    computed: {
      ...mapGetters(["activeGame"]),
    },

    methods: {
      ...mapActions(["destroyGameComponent"]),

      confirmDelete() {
        this.destroyGameComponent({ game: this.activeGame, component: this.deleteTarget })
        this.showDeleteDialog = false
        this.deleteTarget = null
      }
    }
  }
</script>

<style>
.theme--light .sidebar-item--active { background: rgba(0,0,0,0.08) !important; }
.theme--dark  .sidebar-item--active { background: rgba(255,255,255,0.1) !important; }
</style>
